define.alias("@ember/render-modifiers/modifiers/did-update", "calendar/modifiers/did-update");